// extracted by mini-css-extract-plugin
export default {"documentName":"DocumentLink_documentName__SR3+V"};